import { ServiceListItem } from '@/types/service';

/**
 * Changes (inserts/replaces) the second-level domain in a host.
 *
 * @param host   - The host to modify (e.g., "api.communex.app")
 * @param insert - The second-level domain to insert (e.g., "dev", "beta"). Use "" to remove.
 * @returns      - The modified host with the inserted or removed second-level domain.
 *
 * @example
 * _changeThirdLevelInHost('vdsi.intrakommuna.net', 'dev');
 * // => 'vdsi.dev.intrakommuna.net'
 *
 * _changeThirdLevelInHost('vdsi.intrakommuna.net', '');
 * // => 'vdsi.intrakommuna.net' (unchanged)
 */
const _changeThirdLevelInHost = (host: string, insert: string): string => {
  const parts = host.split('.');

  if (parts.length === 3) {
    // e.g. 'api.communex.app'
    return insert ? `${parts[0]}.${insert}.${parts[1]}.${parts[2]}` : host;
  } else if (parts.length === 4) {
    // e.g. 'api.dev.communex.app'
    return insert ? `${parts[0]}.${insert}.${parts[2]}.${parts[3]}` : `${parts[0]}.${parts[2]}.${parts[3]}`;
  }

  return host;
};

export const getServiceList = (host: string): ServiceListItem[] => {
  return [
    {
      title: 'core-dev',
      _title: _changeThirdLevelInHost(host, 'dev'),
      value: _changeThirdLevelInHost(host, 'dev'),
    },
    {
      title: 'core-dev2',
      _title: _changeThirdLevelInHost(host, 'dev2'),
      value: _changeThirdLevelInHost(host, 'dev2'),
    },
    {
      title: 'core-dev3',
      _title: _changeThirdLevelInHost(host, 'dev3'),
      value: _changeThirdLevelInHost(host, 'dev3'),
    },
    {
      title: 'core-dev4',
      _title: _changeThirdLevelInHost(host, 'dev4'),
      value: _changeThirdLevelInHost(host, 'dev4'),
    },
    {
      title: 'core-dev5',
      _title: _changeThirdLevelInHost(host, 'dev5'),
      value: _changeThirdLevelInHost(host, 'dev5'),
    },
    {
      title: 'core-dev6',
      _title: _changeThirdLevelInHost(host, 'dev6'),
      value: _changeThirdLevelInHost(host, 'dev6'),
    },
    {
      title: 'core-beta',
      _title: _changeThirdLevelInHost(host, 'beta'),
      value: _changeThirdLevelInHost(host, 'beta'),
    },
    {
      title: 'core',
      _title: _changeThirdLevelInHost(host, ''),
      value: _changeThirdLevelInHost(host, ''),
    },
  ];
};
